/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".privacy-docs-list[_ngcontent-%COMP%]{min-width:480px;max-height:60vh}.privacy-doc-row[_ngcontent-%COMP%]{display:flex;align-items:center;margin-bottom:16px}.privacy-doc-row[_ngcontent-%COMP%]:last-child{margin-bottom:0}.privacy-doc-btn[_ngcontent-%COMP%]{flex-shrink:0;min-width:96px;margin-right:16px}.privacy-doc-label[_ngcontent-%COMP%]{flex:1}"];
export { styles as styles };
